export const SET_LOADING_DATA = '@orderSplit/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@orderSplit/SET_LOADING_SEND';

export const SET_LOADING_SELECTS = '@orderSplit/SET_LOADING_SELECTS';

export const GET_ALL_REQUEST = '@orderSplit/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@orderSplit/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@orderSplit/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@orderSplit/GET_BY_ID_SUCCESS';

export const GET_PRODUCTS_REQUEST = '@orderSplit/GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = '@orderSplit/GET_PRODUCTS_SUCCESS';

export const SAVE_REQUEST = '@orderSplit/SAVE_REQUEST';
export const SAVE_SUCCESS = '@orderSplit/SAVE_SUCCESS';

export const DELETE_ITEM = '@orderSplit/DELETE_ITEM';
export const EDIT_ITEM = '@orderSplit/EDIT_ITEM';

export const SEARCH = '@orderSplit/SEARCH';

export const SET_PAGE = '@orderSplit/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@orderSplit/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@orderSplit/SET_ORDER';
export const SET_ORDERBY = '@orderSplit/SET_ORDEBY';
